import {
  isAllowedApiOrigin,
  isAuthFunnelStatus,
  isAuthFunnelStep,
} from '@jusbrasil-web/shared-auth-flows/funnel-metrics'
import { NextApiHandler } from 'next'

import { recordAuthFunnelBridgeInvalid, recordAuthFunnelEvent } from './register-auth-funnel'

// Lives next to the counters it feeds, not in `scope:auth`, so every Next app can
// mount it: the emitters span `scope:auth` (signup modal) and `scope:landing-pages`
// (CPF-monitor LP), and NX forbids those scopes from depending on each other.
export const funnelBridgeHandler: NextApiHandler = async (req, res) => {
  if (req.method !== 'POST') {
    res.setHeader('Allow', 'POST')
    res.status(405).end()
    return
  }
  if (!isAllowedApiOrigin(req.headers.origin)) {
    await recordAuthFunnelBridgeInvalid('origin')
    res.status(403).end()
    return
  }
  const body = req.body
  if (body == null || typeof body !== 'object') {
    await recordAuthFunnelBridgeInvalid('parse')
    res.status(400).end()
    return
  }
  const { step, status } = body as Record<string, unknown>
  if (!isAuthFunnelStep(step) || !isAuthFunnelStatus(status)) {
    await recordAuthFunnelBridgeInvalid('label')
    res.status(400).end()
    return
  }
  await recordAuthFunnelEvent({ kind: 'event', step, status })
  res.status(204).end()
}

export const funnelBridgeApiConfig = {
  api: {
    bodyParser: { sizeLimit: '4kb' },
  },
}
